export default __webpack_public_path__ + "static/media/celery_stew.24a71350.jpg";